import React from 'react';
import { Phone, Mail, Globe, MapPin } from 'lucide-react';

const LOGO = '/logo.png';

const Footer = () => (
  <footer className="bg-[#0A0A0A] border-t border-[#4A4A4A]" data-testid="main-footer">
    <div className="max-w-7xl mx-auto px-6 pt-16 pb-8">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
        {/* Brand */}
        <div className="lg:col-span-1">
          <a href="#hero">
            <img src={LOGO} alt="Kadam Patil Projects" className="h-14 sm:h-20 w-auto object-contain mb-4" />
          </a>
          <p className="text-[#9CA3AF] text-sm leading-relaxed mb-4">
            Young and emerging construction and management firm equipped with modern technology and education.
          </p>
          <p className="text-[#C41E3A] text-xs uppercase tracking-widest font-medium">
            Where Innovation Meets Integrity
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="font-heading text-sm text-white mb-5 tracking-widest">Navigation</h4>
          <ul className="space-y-2">
            {[
              { href: '#about',     label: 'About Us' },
              { href: '#services',  label: 'Services' },
              { href: '#process',   label: 'Our Process' },
              { href: '#portfolio', label: 'Portfolio' },
              { href: '#peb',       label: 'PEB Solutions' },
              { href: '#contact',   label: 'Contact' },
            ].map(({ href, label }) => (
              <li key={href}>
                <a
                  href={href}
                  className="text-[#9CA3AF] text-sm hover:text-[#C41E3A] transition-colors"
                  data-testid={`footer-link-${label.toLowerCase().replace(/\s/g, '-')}`}
                >
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Services */}
        <div>
          <h4 className="font-heading text-sm text-white mb-5 tracking-widest">Services</h4>
          <ul className="space-y-2">
            {['Industrial Projects', 'EPC Contracts', 'Project Management', 'Turnkey Solutions', 'Premises Management', 'PEB Structures'].map((s) => (
              <li key={s} className="text-[#9CA3AF] text-sm">{s}</li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 className="font-heading text-sm text-white mb-5 tracking-widest">Contact</h4>
          <ul className="space-y-4">
            <li className="flex items-start gap-3">
              <Phone size={14} strokeWidth={1.5} className="text-[#C41E3A] mt-0.5 shrink-0" />
              <a href="tel:+919881048008" className="text-[#9CA3AF] text-sm hover:text-white transition-colors">+91 9881 048 008</a>
            </li>
            <li className="flex items-start gap-3">
              <Mail size={14} strokeWidth={1.5} className="text-[#C41E3A] mt-0.5 shrink-0" />
              <a href="mailto:info@kadampatilprojects.com" className="text-[#9CA3AF] text-sm hover:text-white transition-colors break-all">info@kadampatilprojects.com</a>
            </li>
            <li className="flex items-start gap-3">
              <Globe size={14} strokeWidth={1.5} className="text-[#C41E3A] mt-0.5 shrink-0" />
              <a href="http://www.kadampatilprojects.com" target="_blank" rel="noopener noreferrer" className="text-[#9CA3AF] text-sm hover:text-white transition-colors">www.kadampatilprojects.com</a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin size={14} strokeWidth={1.5} className="text-[#C41E3A] mt-0.5 shrink-0" />
              <span className="text-[#9CA3AF] text-sm">Jeur, Ahmednagar,<br />Maharashtra 414601</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[#4A4A4A] pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-[#6B7280] text-xs">&copy; {new Date().getFullYear()} Kadam Patil Projects. All rights reserved.</p>
        <p className="text-[#6B7280] text-xs uppercase tracking-widest">Construction &amp; Project Management</p>
      </div>
    </div>
  </footer>
);

export default Footer;
